import { useState } from 'react';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import Icon from './Icon';
import { BRAND } from '../shared/theme/paletteDark';

const ToggleButton = styled('button')({
  appearance: 'none',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 5,
  display: 'grid',
  placeItems: 'center',
  color: BRAND.parchment,
  '&:hover': { opacity: 0.75 },
  // Held out of the way while the event form is up, and saying so.
  '&:disabled': { opacity: 0.3, cursor: 'default' },
  '&:disabled:hover': { opacity: 0.3 },
});

interface ToggleProps {
  side: 'left' | 'right';
  open: boolean;
  /** What it shows and hides, for its label: "filters", "panel". */
  what: string;
  onToggle: () => void;
  disabled?: boolean;
}

/**
 * Shows or hides one sidebar. While the pointer is on it the icon shows the
 * state a click would give; the right one is the left one mirrored, so the
 * filled half is always the side that opens.
 */
export default function SidebarToggle({ side, open, what, onToggle, disabled = false }: ToggleProps) {
  const [hover, setHover] = useState(false);
  const label = `${open ? 'Hide' : 'Show'} ${what}`;
  return (
    <Tooltip title={disabled ? '' : label}>
      <span>
        <ToggleButton
          type="button"
          onClick={onToggle}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          disabled={disabled}
          aria-pressed={open}
          aria-label={label}
        >
          <span style={{ display: 'grid', transform: side === 'right' ? 'scaleX(-1)' : undefined }}>
            <Icon name={(hover ? !open : open) ? 'ui:sidebarOn' : 'ui:sidebarOff'} size={20} />
          </span>
        </ToggleButton>
      </span>
    </Tooltip>
  );
}
